import { PubSubService } from './../service/pubSub.service';
import { wicService } from '../services/wic/wic.service';
import { SystemService } from '../service/system.service';
/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var walkincenterComponent = (function () {
    function walkincenterComponent(wicS, pubsub) {
        this.wicS = wicS;
        this.pubsub = pubsub;
        this.doughnutChartLabels = [];
        this.doughnutChartData = [];
        this.doughnutChartColors = [];
        this.selectedOption = 'overAll';
        this.device = null;
        this.systemService = new SystemService();
        this.options = {
            "animation": {
                "duration": 0
            },
            "title": {
                "display": true,
                "text": "AVERAGE WAITING TIME",
                "fontSize": 16,
                "position": "top"
            },
            "legend": {
                "display": true,
                "position": "bottom"
            },
            "tooltips": {
                "callbacks": {},
                "bodyFontSize": 10,
                "displayColors": false
            },
            pieceLabel: {
                render: 'percentage',
                arc: true,
                fontSize: 14,
                fontStyle: 'bold',
                fontColor: '#000',
                position: 'border'
            },
            segmentShowStroke: true,
            segmentStrokeColor: "#fff",
            segmentStrokeWidth: 2,
            percentageInnerCutout: 50,
            responsive: true,
            maintainAspectRatio: true,
            showScale: true,
            circumference: Math.PI,
            rotation: -1 * Math.PI
        };
        this.dataObject = {};
        this.wicData = {};
    }
    walkincenterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.checkMedia();
        this.getDataSub = this.pubsub.$sub('getData', function (eventObject) {
            _this.getWicData();
        });
        this.getWicData();
        if (window.navigator.userAgent.indexOf('iPhone') > -1) {
            this.device = 'ios';
        }
    };
    walkincenterComponent.prototype.getWicData = function (selectedOption) {
        var _this = this;
        this.wicS.getWicData().then(function (result) {
            if (result[0]) {
                _this.dataObject = result[0];
                if (selectedOption) {
                    _this.selectedOption = selectedOption;
                }
                _this.wicData = _this.dataObject[_this.selectedOption];
            }
        });
    };
    walkincenterComponent.prototype.checkMedia = function () {
        if (window.matchMedia('(max-width: 599px)').matches) {
            this.options.legend.position = 'top';
        }
    };
    walkincenterComponent.prototype.ngOnDestroy = function () {
        this.getDataSub.unsubscribe();
    };
    return walkincenterComponent;
}());
export { walkincenterComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/walkincenterComponent/walkincenter.component.ts.pre-build-optimizer.js